/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamCorrectExam202,
  PostApiV1ExamCorrectExam400,
  PostApiV1ExamCorrectExam401,
  PostApiV1ExamCorrectExam500,
  PostApiV1ExamCorrectExamMutationRequest,
  PostApiV1ExamCorrectExamMutationResponse,
} from "../../types/examCorrectionDashboardController/PostApiV1ExamCorrectExam.ts";
import { examItemAnswerTextCorrectionViewModelSchema } from "../examItemAnswerTextCorrectionViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamCorrectExam202Schema =
  z.boolean() as unknown as ToZod<PostApiV1ExamCorrectExam202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamCorrectExam400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamCorrectExam400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamCorrectExam401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamCorrectExam401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamCorrectExam500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamCorrectExam500>;

export const postApiV1ExamCorrectExamMutationRequestSchema = z.lazy(
  () => examItemAnswerTextCorrectionViewModelSchema,
) as unknown as ToZod<PostApiV1ExamCorrectExamMutationRequest>;

export const postApiV1ExamCorrectExamMutationResponseSchema = z.lazy(
  () => postApiV1ExamCorrectExam202Schema,
) as unknown as ToZod<PostApiV1ExamCorrectExamMutationResponse>;
